<script>
  export let title;
  import { conversion, lang } from "../store/store";
  import { meta } from "tinro";
  const route = meta();
  console.log($lang);
  let router = $route.url;
  console.log(router);
  console.log($conversion);
</script>

<div class="mainContent">
  <div class="tasksContainer">
    <div class="dashboard">
      <i class="bx bx-left-arrow-alt" />
      {#if router.indexOf("TaskItemDetails") == -1}
        <a href="/">
          <h5>{$conversion[$lang].backDashboard.back}</h5>
        </a>
      {:else}
        <a href="/tasks">
          <h5>{$conversion[$lang].backDashboard.TaskbackRoute}</h5>
        </a>
      {/if}
    </div>
    <div class="TitleContainer">
      <div class="text">
        <h1>{title}</h1>
      </div>
    </div>
  </div>
</div>

<style>
  a {
    color: #333;
  }

  .tasksContainer {
    padding-top: 1rem;
    padding-bottom: 20px;
  }

  .dashboard {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;
  }

  .dashboard h5 {
    margin: 0;
    font-weight: 400;
  }

  .TitleContainer {
    /* display: flex;
        align-items: center;
        justify-content: space-between; */
    display: flex;
    justify-content: space-between;
    /* background-color: green; */
  }

  .text {
    display: flex;
    align-items: center;
    font-family: "Poppins", sans-serif;
  }

  .text h1 {
    font-weight: 500 !important;
    margin: 0;
  }

  .bx-left-arrow-alt {
    font-size: 1.3em;
  }
</style>
